import React from 'react'
import { withNamespaces } from "react-i18next"
import { MapPin, Grid, Mail, CreditCard, Check } from "lucide-react"
import { connect } from 'react-redux'

class StepBarBaqueira extends React.Component {

  getGradientStyle() {
    const { qrData } = this.props
    const { primaryColor, secondaryColor } = qrData?.headerConfig || {}
    if (primaryColor && secondaryColor) {
      return `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`
    }
    return 'linear-gradient(90deg, #0a1d3d, #1a3a6b)'
  }

  getButtonGradient() {
    const { qrData } = this.props
    const { buttonColor1, buttonColor2 } = qrData?.headerConfig || {}
    if (buttonColor1 && buttonColor2) {
      return `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`
    }
    return 'linear-gradient(135deg, #0a1d3d, #1a3a6b)'
  }

  getButtonColor1() {
    const { qrData } = this.props
    return qrData?.headerConfig?.buttonColor1 || '#1a3a6b'
  }

  hexToRgba(hex, alpha) {
    const h = hex.replace('#', '')
    const r = parseInt(h.substring(0, 2), 16)
    const g = parseInt(h.substring(2, 4), 16)
    const b = parseInt(h.substring(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  renderStep(stepNumber, currentStep, label, Icon) {
    const isActive = currentStep === stepNumber
    const isOld    = currentStep > stepNumber
    const buttonGradient = this.getButtonGradient()

    const iconStyle = isActive
      ? { animation: 'bqStepPulseActive 1s ease-in-out infinite alternate' }
      : isOld
        ? { background: buttonGradient }
        : {}

    const iconCls  = `bq-sb-icon${isActive ? ' bq-sb-icon--active' : ''}${isOld ? ' bq-sb-icon--done' : ''}`
    const labelCls = `bq-sb-label${isActive ? ' bq-sb-label--active' : ''}${isOld ? ' bq-sb-label--done' : ''}`

    return (
      <div className="bq-sb-step">
        <div className={iconCls} style={iconStyle}>
          {isOld ? <Check size={18} /> : <Icon size={18} />}
        </div>
        <span className={labelCls}>{label}</span>
      </div>
    )
  }

  render() {
    const { step, t }      = this.props
    const barGradient      = this.getGradientStyle()
    const buttonGradient   = this.getButtonGradient()
    const btnColor1        = this.getButtonColor1()
    const inactiveBg       = this.hexToRgba(btnColor1, 0.20)
    const inactiveColor    = this.hexToRgba(btnColor1, 0.60)

    return (
      <>
        <style>{`
          @keyframes bqStepPulseActive {
            from { background: ${buttonGradient}; color: var(--customer-button-text, #ffffff); }
            to   { background: ${inactiveBg};     color: ${inactiveColor}; }
          }
        `}</style>

        <div className="bq-sb" style={{ background: barGradient }}>
          <div className="bq-sb-inner">

            {this.renderStep(1, step, t('Zona'), MapPin)}

            <div
              className={`bq-sb-line${step > 1 ? ' bq-sb-line--done' : ''}`}
              style={step > 1 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(2, step, t('Taquilla'), Grid)}

            <div
              className={`bq-sb-line${step > 2 ? ' bq-sb-line--done' : ''}`}
              style={step > 2 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(3, step, t('Email'), Mail)}

            <div
              className={`bq-sb-line${step > 3 ? ' bq-sb-line--done' : ''}`}
              style={step > 3 ? { background: buttonGradient } : {}}
            />

            {this.renderStep(4, step, t('Pago'), CreditCard)}

          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
})

export default withNamespaces()(connect(mapStateToProps)(StepBarBaqueira))
